export default {
  quizConfig: {},
  currentQuestionIndex: 0,
  currentChoiceIndex: 0,
  quizSubmit: { quizanswers: {} },
  outfitResult: {},
  completedPercentage: 0,
  completedSteps: 0,
}
